<!-- Fragment.vue -->
<template>
  <slot></slot>
</template>
